export default {
  computed: {
    isMobile (): boolean {
      // Chrome version >= 101
      if (navigator?.userAgentData?.mobile) return true

      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  }
}
